<template>
  <main>
    <AppSubTitle v-text="'Угадай автора текста'"/>

    <ul>
      <AppButton
        v-for="author of authors"
        variant="gradient"
        :key="author._id"
        :class="{ answer: author.answer }"
        @click="$emit('finish:author', author._id)"
        v-text="author.name"
        bold
      />
    </ul>
  </main>
</template>


<script>
import AppButton from '@/components/game/ui/AppButton';
import AppSubTitle from '@/components/game/ui/AppSubTitle';

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'AppGame_ViewAuthor',

  components: {
    AppButton,
    AppSubTitle,
  },

  data: () => ({
    authors: {},
  }),

  async created() {
    this.authors = await this.getAuthorsBySoundId();
    if (!this.authors.length) this.$emit('finish:author');
  },

  methods: {
    ...mapActions([
      'getAuthorsBySoundId',
    ]),
  },
};
</script>


<style lang="scss" scoped>
main {
  gap: 48px !important;
  align-items: center;

  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;

    & > button {
      cursor: pointer;
      border-radius: 8px !important;
      padding: 24px !important;

      &.answer {
        outline: 2px dashed;
      }
    }
  }
}
</style>